/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { BaseAddressComponentMapper } from './base-address-component.mapper';
import { AddressDTO } from "@well/address-management-domain-model";

export class StateAddressComponentMapper extends BaseAddressComponentMapper {

  private stateRedundantWords: string[] = ['Județul '];

  mapAddress(address: AddressDTO) {
    const state = this.addressComponent?.long_name;
    address.state = this.removeRedundantWords(state);
  }

  private removeRedundantWords(state: string): string {
    if (!state) {
      return '';
    }
    for (const prefix of this.stateRedundantWords) {
      if (state.includes(prefix)) {
        state = state.replace(prefix, '');
      }
    }
    return state;
  }
}
